<template>
    <div>
        <div class="flx aic jcsb pr" style="padding: 0 0.3rem; height: 1.5rem;">
            <i class="el-icon-s-fold" style="font-size: 0.8rem;" @click="ddyybm()"></i>
            <div style="width: 3.23rem; height: 1.23rem;">
                <img style="width: 3.23rem; height: 1.23rem;" :src="data_list.logo" alt="">
            </div>
            <div style="width: 0.8rem;"></div>
            <el-collapse-transition>
                <div class="pa bkgf" style="width: 10rem; z-index: 9999; top: 1.5rem; left: 0;" v-show="show3">
                    <div v-for="(item, index) in mune_list" :key="index" class="flx" :class="indextap==item.id?'active':''" style="padding: 0.5rem 0.5rem;" @click="tapindex(item.name,item.page)">
                        <i style="font-size: 0.6rem; height: 0.8rem; line-height: 0.8rem;" :class="item.icon"></i>
                        <div style="font-size: 0.4rem; height: 0.8rem; line-height: 0.8rem; margin-left: 0.4rem;">{{item.name}}</div>
                    </div>
                </div>
            </el-collapse-transition>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TopPage',
    data () {
        return {
            show3: false,
            data_list: '',
            mune_list: [{id: 6, name: '首页', page: 'index6', icon: 'el-icon-house'},
            {id: 7, name: '关于我们', page: 'index7', icon: 'el-icon-user'},
            {id: 8, name: '合作伙伴', page: 'index8', icon: 'el-icon-trophy'},
            {id: 9, name: '最新资讯', page: 'index9', icon: 'el-icon-document'},
            {id: 10, name: '加入我们', page: 'index10', icon: 'el-icon-chat-line-square'},
            ],
            indextap: ''
        }
    },
    methods:{
        ddyybm() {
            this.show3 = !this.show3;
        },

        tapindex(name,page) {
            this.$router.push({
                path: '/' + page,
                query: {
                    name: name
                }
            })
            this.show3 = false;
        },

        toindex() {
            this.$router.push({
                path: '/index',
                query: {
                    name: '首页'
                }
            })
        },
        sing(id) {
            this.indextap = id;
        },

        getData() {
            this.$post('index.php?s=/api/index/pub_api', {
                wxapp_id: 10001
            })
            .then((res) => {
                if(res.code == 1) {
                    this.data_list = res.data.list;
                }
            }) 
        },
    },
    created() {
        this.getData();
    },
}
</script>

<style>
    .top-box{
        height: 75px;
    }
    .active{
        color: #fff;
        background-color: #C8161D;
    }
    .mune-list{
        min-width: 90px;
        cursor: pointer;
    }
    .mune-list:hover{
        color: #fff;
        background-color: #C8161D;
    }
</style>


// WEBPACK FOOTER //
// src/components/partialset/toppage2.vue